export default "__VITE_ASSET__tdp57qvT__"